import { render, staticRenderFns } from "./salaryitem.vue?vue&type=template&id=7650d209"
import script from "./salaryitem.vue?vue&type=script&lang=js"
export * from "./salaryitem.vue?vue&type=script&lang=js"
import style0 from "./salaryitem.vue?vue&type=style&index=0&id=7650d209&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports